<template>
  <div class="card">
    <div class="card-body mb-0">
      <CreateEditLessonModal
        v-if="showCreateEditLessonModal"
        :courseId="courseId"
        :moduleId="moduleId"
        :lessonId="lessonId"
        @closeModal="closeCreateEditLessonModal"
      />
      <CreateEditQuestionModal
        v-if="showCreateEditQuestionModal"
        typeQuestion="lesson"
        :courseId="courseId"
        :moduleId="moduleId"
        :lessonId="lessonId"
        :questionId="questionIdSelected"
        @closeModal="closeModal"
      />
      <CreateAttachmentModal
        v-if="showCreateAttachmentModal"
        :courseId="courseId"
        :moduleId="moduleId"
        :lessonId="lessonId"
        @closeModal="closeModal"
      />
      <DeleteAttachmentModal
        v-if="showDeleteAttachmentModal"
        :courseId="courseId"
        :moduleId="moduleId"
        :lessonId="lessonId"
        :attachmentId="attachmentIdSelected"
        @closeModal="closeModal"
      />
      <LoadingData v-if="loadData" />
      <div v-else>
        <DetailLesson
          :lesson="lesson"
          @editLesson="showCreateEditLessonModal = true"
        />
        <VideoLesson v-if="lesson.type == 1" :link="lesson.link" />
        <QuestionsLesson
          v-if="lesson.type == 2"
          :questions="lesson.questions"
          @createQuestion="createEditQuestion"
          @editQuestion="createEditQuestion"
        />
        <AttachmentsLesson
          :attachments="lesson.attachments"
          @createAttachment="showCreateAttachmentModal = true"
          @deleteAttachment="deleteAttachment"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CreateEditLessonModal from '@/components/courses/lessons/CreateEditLessonModal.vue'
import CreateEditQuestionModal from '@/components/courses/questions/CreateEditQuestionModal.vue'
import CreateAttachmentModal from '@/components/courses/attachments/CreateAttachmentModal.vue'
import DeleteAttachmentModal from '@/components/courses/attachments/DeleteAttachmentModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import DetailLesson from '@/components/courses/lessons/details/DetailLesson.vue'
import VideoLesson from '@/components/courses/lessons/details/VideoLesson.vue'
import QuestionsLesson from '@/components/courses/lessons/details/QuestionsLesson.vue'
import AttachmentsLesson from '@/components/courses/lessons/details/AttachmentsLesson.vue'

export default {
  name: 'DetailsLesson',

  components: {
    CreateEditLessonModal,
    CreateEditQuestionModal,
    CreateAttachmentModal,
    DeleteAttachmentModal,
    LoadingData,
    DetailLesson,
    VideoLesson,
    QuestionsLesson,
    AttachmentsLesson,
  },

  props: {
    courseId: {
      type: String,
      required: true,
    },
    moduleId: {
      type: String,
      required: true,
    },
    lessonId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showCreateEditLessonModal: false,
      showCreateEditQuestionModal: false,
      showCreateAttachmentModal: false,
      showDeleteAttachmentModal: false,
      lesson: {},
      questionIdSelected: null,
      attachmentIdSelected: null,
    }
  },

  methods: {
    async getLesson() {
      try {
        this.lesson = await this.$store.dispatch('getLesson', {
          courseId: this.courseId,
          moduleId: this.moduleId,
          lessonId: this.lessonId,
        })
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditQuestion(questionId) {
      this.questionIdSelected = questionId || null
      this.showCreateEditQuestionModal = true
    },

    deleteAttachment(attachmentId) {
      this.attachmentIdSelected = attachmentId
      this.showDeleteAttachmentModal = true
    },

    closeCreateEditLessonModal(reloadData) {
      if (reloadData) {
        this.getLesson()
        this.$emit('loadListLessons')
      }
      this.showCreateEditLessonModal = false
    },

    closeModal(reloadData) {
      if (reloadData) {
        this.getLesson()
      }
      this.showCreateEditQuestionModal = false
      this.showCreateAttachmentModal = false
      this.showDeleteAttachmentModal = false
    },
  },

  mounted() {
    this.getLesson()
  },
}
</script>

<style scoped>
.card {
  background-color: #f5f5f5;
  margin-bottom: 0;
}
</style>
